// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4114af5e","977":"8e4cfaa5"}[chunkId] + ".chunk.js";
};